// extracted by mini-css-extract-plugin
export default {"container":"AddPaymentMethod_container__dxIpX","icon":"AddPaymentMethod_icon__4lSIV"};